/**************************************************************************************************************************
 Copyright (c) 2024 WorkEarly Results LLP

     Name: utils.ts
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { v4 as uuidv4 } from 'uuid';
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const getUniqueId = (prefix: string = 'prefix') => `${prefix}_${uuidv4()}`;

const handlePreloaderRendering = () => {
  const onPageLoad = () => {
    const preloader = document.getElementById('preloader');
    if (preloader) {
      if (!preloader.classList.contains('hide')) {
        preloader.classList.add('hide');
      }
    }
  };

  if (document.readyState === 'complete') {
    onPageLoad();
  } else {
    window.addEventListener('load', onPageLoad);
    return () => window.removeEventListener('load', onPageLoad);
  }
};

const Utils = {
  getUniqueId,
  handlePreloaderRendering
};

export default Utils;
